module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state) ? _c('div', {
    staticClass: "alertBox",
    class: _vm.state ? 'alertBoxShow' : ''
  }, [_c('div', {
    staticClass: "alertBoxCont"
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dce191f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/alertBox/src/alertBox.vue
// module id = 543
// module chunks = 0